import { convertDuration } from "../convertDuration";
const getBookingContent = ({ name, bookingData: { durations } }, t) => ({
  title: name,
  info: { leftSubtitle: durations && convertDuration(durations, t) },
  buttonText: t("VerticalEmbed_Bookings_Button")
});
const getEventContent = ({ name, eventData: { scheduling, location } }, t) => ({
  title: name,
  info: { leftSubtitle: scheduling, rightSubtitle: location },
  buttonText: t("VerticalEmbed_Events_Button")
});
const getProductContent = ({ name }, t) => ({
  title: name,
  buttonText: t("VerticalEmbed_Products_Button")
});
const contentTypeMapGetter = {
  BOOKING: getBookingContent,
  EVENT: getEventContent,
  PRODUCT: getProductContent
};
const verticalsDataBuilder = (componentData, t, changeBaseUrl = (x) => x) => {
  const { url, image } = componentData;
  return {
    url: changeBaseUrl(url),
    imageSrc: image.src.url,
    imageWidth: image.width,
    imageHeight: image.height,
    content: contentTypeMapGetter[componentData.type](componentData, t)
  };
};
export {
  verticalsDataBuilder
};
//# sourceMappingURL=verticalsDataBuilder.js.map
